// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2pGb2","footer":"styles_footer__3jUvs","passCodeTooltip":"styles_passCodeTooltip__30ubm"};